export const NotFound = () => {
    return (
        <p className="text-center"><strong>404</strong> - a keresett oldal nem található.</p>
    )
}